module.exports = __webpack_public_path__ + "static/img/actions-primary.c8cd4aeb.svg";